import React from 'react';
import Header from './components/Header';
import Coran from './components/Coran';
import Sonna from './components/Sonna';
import Footer from './components/Footer';
import './App.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  return (
    <Router>
    <div className="App">
      <Header />
      <Switch>
        <Route exact path="/">
          <Coran />
        </Route>
        <Route exact path="/coran">
          <Coran />
        </Route>
        <Route exact path="/sonna">
          <Sonna />
        </Route>
      </Switch>
      <Footer />
    </div>
    </Router>
  );
}

export default App;
